import { registerComponent } from "helpers";
import SearchspringComponent from "searchspring";

registerComponent(
  "results-sort",
  class ResultsSort extends SearchspringComponent {
    constructor() {
      super();

      this.template = this.querySelector('[data-template="sort"]');
    }

    render({ sorting }) {
      if (!sorting) {
        return;
      }

      const { options } = sorting;

      if (!options) {
        return;
      }

      this.resultsSort = this.template.content.cloneNode(true);
      this.select = this.resultsSort.querySelector(
        '[data-template-element="select"]',
      );

      options.forEach((option) => {
        this.injectOption(option);
        this.injectHiddenInput(option);
      });

      this.appendChild(this.resultsSort);

      this.select.addEventListener("change", this.handleChange.bind(this));
    }

    injectOption(option) {
      const optionElement = document.createElement("option");

      optionElement.value = `${option.field}=${option.direction}`;
      optionElement.textContent = option.label;
      optionElement.selected = option.active;

      this.select.appendChild(optionElement);
    }

    injectHiddenInput(option) {
      const hiddenInput = document.createElement("input");

      hiddenInput.type = "hidden";
      hiddenInput.name = `sort.${option.field}`;
      hiddenInput.value = option.direction;
      hiddenInput.disabled = !option.active;

      this.appendChild(hiddenInput);
    }

    handleChange(event) {
      const [name, value] = event.target.value.split("=");

      this.querySelectorAll(`input[name*="sort"]`).forEach((input) => {
        input.disabled = input.name !== `sort.${name}` || input.value !== value;
      });
    }
  },
);
